<template>
  <v-app>
    <the-header></the-header>
    <v-main>
      <v-container fluid class="pt-2 pt-sm-4">
        <v-row dense>
          <!-- Left Sidebar: Category List -->
          <v-col cols="12" sm="3" lg="2" class="pb-0 pb-sm-3">
            <the-sidebar></the-sidebar>
          </v-col>

          <!-- Main Content: Router View -->
          <v-col cols="12" sm="9" lg="10" class="pt-0 pt-sm-3">
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-footer border class="bg-white">
            <v-row justify="center" no-gutters>
                <v-col class="text-center mt-4" cols="12">
                    <a href="mailto:contact@swiun.kr" class="text-decoration-none text-grey-darken-1 text-body-2 font-weight-medium transition-swing hover:text-primary">
                        문의: contact@swiun.kr
                    </a>
                </v-col>
                <v-col class="text-center mb-4 mt-2" cols="12">
                    <small class="text-grey-lighten-1" style="font-size: 12px;">&copy; 2025-{{ new Date().getFullYear() }} swiun.kr</small>
                </v-col>
            </v-row>
        </v-footer>
  </v-app>
</template>

<script>
import TheHeader from './components/TheHeader.vue'
import TheSidebar from './components/TheSidebar.vue'

export default {
  name: 'App',
  components: {
    TheHeader,
    TheSidebar
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.v-btn:active {
  transform: scale(0.95);
  transition: transform 0.1s ease-in-out;
}
</style>
